/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-06 17:46:11
 * @LastEditTime: 2025-03-06 17:58:11
 */
import React from "react";
import noData from './imgs/noData.png'
import './index.scss'

interface INoProps { 
  title?:string,
}
const NoData: React.FC<INoProps> = (props) => {
  const {
    title = '暂无数据'
  } = props;
  return <div className="no-data-container">
    <img src={noData} alt="" />
    <p className="no-data-title" dangerouslySetInnerHTML={{ __html: title }}></p>
  </div>;
}

export default NoData;
